import { Box, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { MeetingGuidanceWidget } from '@app/features/meetingGuidance';

export const MeetingGuidancePage = () => {
  const { planResultRootId, planResultTypeId } = useParams<{
    planResultRootId: string;
    planResultTypeId: string;
  }>();
  const navigate = useNavigate();

  if (!planResultRootId || !planResultTypeId) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="par02Regular">
          Missing required parameters: planResultRootId and planResultTypeId
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: '100vw',
        minHeight: '100vh',
        backgroundColor: 'grey.100',
      }}
    >
      <MeetingGuidanceWidget
        planResultRootId={planResultRootId}
        planResultTypeId={planResultTypeId}
        onClose={() => navigate(-1)}
      />
    </Box>
  );
};
